import PropTypes from "prop-types";

export const FocalPointPropType = PropTypes.shape({
  aspectRatio: PropTypes.number,
  focalX: PropTypes.number.isRequired,
  focalY: PropTypes.number.isRequired,
  height: PropTypes.number,
  width: PropTypes.number,
});
